module.exports = __webpack_public_path__ + "03e91b6a8b04b94ae7afcf660721f81d.svg";